import axios from "axios";
const checkEnvironment = (url, apiUrl) => {
  const Environment = process.env.NODE_ENV;
  if (Environment === "development") return url + apiUrl;
  if (Environment === "production")
    return window.env.REACT_APP_API_HOST + apiUrl;
};
const _basic = window.env.REACT_APP_API_DEVELOPMENT_HOST;
const _getProduct = "/Product";

const getProduct = axios.create({
  baseURL: checkEnvironment(_basic, _getProduct)
});



/**
 * @param {number} langId 語系代號
 * @param {number} storeId 店家代號
 */
export const getAllProduct = async (langId, storeId) => {
  return await getProduct.get("/GetProductAll", {
    params: {
      languageID: langId,
      storeID: storeId
    }
  });
};

/**
 * @param {number} langId 語系代號
 * @param {number} storeId 店家代號
 */
export const getBranchProduct = async (langId, storeId) => {
  return await getProduct.get("/GetProductStore", {
    params: {
      languageID: langId,
      storeID: storeId
    }
  });
};

/**
 * @param {number} langId 語系代號
 * @param {number} productId 語系代號
 */
export const getSpecificProductItem = async (langId, productId) => {
  return await getProduct.get("/GetProductTasteSpecification", {
    params: {
      languageID: langId,
      productID: productId
    }
  });
};

/**
 * @param {number} langId 語系代號
 */
export const getTagList = async (langId) => {
  return await getProduct.get("/GetTagList", {
    params: {
      languageID: langId
    }
  });
};

/**
 * @param {number} langId 語系代號
 * @param {number} storeId 門市代號
 */
export const GetStaffMenu = async (langId, storeId) => {
  return await getProduct.get("/GetStaffMenu", {
    params: {
      languageID: langId,
      storeID: storeId
    }
  });
};

/**
 * @param {number} langId 語系代號
 * @param {number} productId 產品代號
 */
export const GetStaffMenuDetail = async (langId, productId) => {
  return await getProduct.get("/GetStaffMenuDetail", {
    params: {
      languageID: langId,
      productID: productId
    }
  });
};
